(function(window, app, overwatch){
	var heroes = {};
	heroes.init = function init() {
		overwatch.HeroSelector.init({
			$container: $('#heroes-selector-container'),
			$sizer: false,
			$navigationLinks: $('#hero-selector-navigation-selector .navigation-link'),
			itemSelector: '#heroes-selector-container .hero-portrait-detailed-container'
		});
		
		var hash = location.href.substr(location.href.indexOf('#')+1).toUpperCase();
		if(['OFFENSE', 'DEFENSE', 'TANK', 'SUPPORT'].indexOf(hash) !== -1) {
			overwatch.HeroSelector.filter(hash);
		}
		
	};
	app.extend({ heroes: heroes });
}(window, window.app, window.overwatch));
